export default function (Vue) {
  //let setAuthenticatedUser = {}

  Vue.auth = {
    setToken (username, token, expiration) {
      localStorage.setItem('username', username)
      //localStorage.setItem('sid', sid)
      localStorage.setItem('token', token)
      localStorage.setItem('expiration', expiration)
    },
    getToken () {
      var username = localStorage.getItem('username')
      //var sid = localStorage.getItem('sid')
      var token = localStorage.getItem('token')
      var expiration = localStorage.getItem('expiration')

      if( ! token || ! expiration )
        return null

      if(Date.now() > parseInt(expiration)) {
        this.destroyToken()
      } else {
        return {
          //sid: sid,
          token: token
        }
      }
    },
    destroyToken () {
      localStorage.removeItem('username')
      //localStorage.removeItem('sid')
      localStorage.removeItem('token')
      localStorage.removeItem('expiration')
    },
    isAuthenticated () {
      if(this.getToken())
        return true
      else
        return false
    }
    // setAuthenticatedUser (data) {
    //     setAuthenticatedUser = data
    // },
    // getAuthenticatedUser (k) {
    //     return setAuthenticatedUser[k]
    // }
  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/config/auth.js